<template>
  <div>
    <v-dialog v-model="loading" persistent width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{i18n[language].wait}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 md3>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-card-text>
            <v-layout row wrap v-if="!loading" align-center py-5>
              <v-flex xs12 v-if="paid">
                <v-layout row wrap>
                  <v-flex xs12 class="container">
                    <svg id="successAnimation" class="animated" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 70 70">
                      <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#005596" stroke-width="2" stroke-linecap="round" fill="transparent"/>
                      <polyline id="successAnimationCheck" stroke="#005596" stroke-width="2" points="23 34 34 43 47 27" fill="transparent"/>
                    </svg>
                  </v-flex>
                  <v-flex xs12 :class="`${language=='ar' ? 'arFont' : ''} text-xs-center`" style="font-size:24px;color:#005596;font-weight:bold;">
                    {{i18n[language].success}}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="!paid">
                <v-layout row wrap>
                  <v-flex xs12 class="container">
                    <svg id="failureAnimation" class="animated" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 70 70">
                      <circle id="failureAnimationCircle" cx="35" cy="35" r="24" stroke="#005596" stroke-width="2" stroke-linecap="round" fill="transparent"/>
                      <polyline class="failureAnimationCheckLine" stroke="#005596" stroke-width="2" points="25,25 45,45" fill="transparent" />
                      <polyline class="failureAnimationCheckLine" stroke="#005596" stroke-width="2" points="45,25 25,45" fill="transparent" />
                    </svg>
                  </v-flex>
                  <v-flex xs12 :class="`${language=='ar' ? 'arFont' : ''} text-xs-center`" style="font-size:24px;color:#005596;font-weight:bold;">
                    {{i18n[language].failed}}
                  </v-flex>
                  <v-flex xs12 :class="`${language=='ar' ? 'arFont' : ''} text-xs-center`" style="font-size:24px;color:#005596;font-weight:bold;">
                    {{message}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>  
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
      loading:false,
      lead:null,
      token:null,
      paid:false,
      language:'en',
      message:null,
      i18n:{
        ar:{
          wait:'الرجاء الانتظار',
          success:'تم الدفع بنجاح',
          failed:'لم تنجح عملية الدفع',
        },
        en:{
          wait:'Please Wait',
          success:'Payment was successful',
          failed:'Payment failed',
        }
      },
      cart_token:null,
    }
  }, 
  methods:{
    async decrypt(text) {
      let data = {
        text:text
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      console.log(a)
      return a.decrypted

    },
    async encrypt(text) {
      let data = {
        text:text,
        action:'encrypt'
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      console.log(a)
      return a.encrypted

    },
    async sendWANotification(lead){
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      let b = Object.keys(a)
      let settings_cc = Object.values(a).map((x, i)=>{
        return {
          ...x,
          key:b[i]
        }
      })
      function getPolicyLink(cc){
        let pl = settings_cc.filter(x=>cc && x.company_code == cc.toUpperCase())
        if(pl.length) {
          return pl[0].policy
        } else {
          return "https://www.ashyaat.net/the-return-policy-ar"
        }
      }
      function getDeliveryDays(cc){
        let pl = settings_cc.filter(x=>cc && x.company_code == cc.toUpperCase())
        if(pl.length) {
          return pl[0].ddays
        } else {
          return '3-8'
        }
      }
      let msgSettings = {
        arMale: {
          name:``,
          payment_url:null,
          order:``,
          online_total:``,
          delivery:`${getDeliveryDays(lead.company_code)}`,
          message: function(){ 
            return `عميلنا العزيز السيد ${this.name},\n\n`+
            `تمت عملية الدفع بنجاح عن الطلب:\n`+
            `${this.order}`+
            `اجمالي قيمة الطلب ${this.online_total}\n`+
            `${parseFloat(lead.tax)>0 ? 'شامل الضريبة' : ''}\n`+
            `سيتم التواصل معكم من قبل شركة التوصيل خلال ${this.delivery} يام لاستلام الطلب\n\n`+

            `لسياية التبديل والارجاع اضغط الرابط في الاسفل : ${getPolicyLink(lead.company_code)} \n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        arFemale:{
          name:``,
          payment_url:null,
          order:``,
          online_total:``,
          delivery:`${getDeliveryDays(lead.company_code)}`,
          message: function(){ 
            return `عميلتنا العزيزة السيدة ${this.name},\n\n`+
            `تمت عملية الدفع بنجاح عن الطلب:\n`+
            `${this.order}`+
            `اجمالي قيمة الطلب ${this.online_total}\n`+
            `${parseFloat(lead.tax)>0 ? 'شامل الضريبة' : ''}\n`+
            `سيتم التواصل معكم من قبل شركة التوصيل خلال ${this.delivery} يام لاستلام الطلب\n\n`+

            `لسياية التبديل والارجاع اضغط الرابط في الاسفل : ${getPolicyLink(lead.company_code)} \n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        enMale:{
          name:``,
          payment_url:null,
          order:``,
          online_total:``,
          delivery:`${getDeliveryDays(lead.company_code)}`,
          message:function(){
            return `Dear valued customer Mr. ${this.name},\n` +
            `Your order has been paid for which contains:\n` +
            `${this.order}` +
            `and the total order amount is ${this.online_total}\n` +
            `${parseFloat(lead.tax)>0 ? 'including tax' : ''}\n`+
            `The delivery company will contact with you in ${this.delivery} days to arrange the delivery time.\n\n`+

            `For return policy , please click the link below: ${getPolicyLink(lead.company_code)} \n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n`
          }
        },
        enFemale:{
          name:``,
          payment_url:null,
          order:``,
          online_total:``,
          delivery:`${getDeliveryDays(lead.company_code)}`,
          message:function(){
            return `Dear valued customer Ms. ${this.name},\n` +
            `Your order has been paid for which contains:\n` +
            `${this.order}` +
            `and the total order amount is ${this.online_total}\n` +
            `${parseFloat(lead.tax)>0 ? 'including tax' : ''}\n`+
            `The delivery company will contact with you in ${this.delivery} days to arrange the delivery time.\n\n`+

            `For return policy , please click the link below: ${getPolicyLink(lead.company_code)} \n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n` 
          }
        },
      }  
      let msgObj = msgSettings[lead.language + lead.gender]
      msgObj.name = lead.name
      let order = lead.order
      let productsImages = []
      let notOrder = ''
      order.forEach(item=>{
        notOrder += `${item.quantity} X ${item.product}\n`
      })
      msgObj.order = notOrder
      msgObj.online_total = lead.online_total
      console.log(msgObj.message())
      let post = {
        number:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
        message:msgObj.message(),
        country:lead.company_code.toUpperCase()
      }
      const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
      const headers = {
        'Accept': 'application/json'
      }
      try {
        let send = await axios.post(`https://ashyaatcrm.uc.r.appspot.com/WAnew`, post, {headers:headers}).then(x=>x.data)
        if(send.success) {
        } else if(send.qr){
        } else {
        }
      } catch (error) {
      }
    },
    async GetPaymentStatus(cart_token){
      this.loading = true
      let data = {
        cart_token
      }
      try {
        let a = await axios.post(`${apiBase}/GetPaymentStatus`, data, headers).then(x=>x.data.data)
        console.log(a)
        if(a && a.id && a.amount && a.currency && a.customer && a.customer.merchantCustomerId && a.result && (a.result.code == '000.000.000' || a.result.code == '000.600.000')){
          await store.collection('leads').doc(a.customer.merchantCustomerId).update({
            paid:true,
            payment_tried:true,
            payment_status:'success',
            payment_api_response:true,
            payment_timestamp:new Date().getTime(),
            payment_date:getCDate(),
            payment_amount:a.amount,
            payment_currency:a.currency,
            payment_result:a.result.description
          })
          try {
            let lead = await store.collection('leads').doc(a.customer.merchantCustomerId).get().then(x=>x.data())
            lead.key = a.customer.merchantCustomerId
            this.sendWANotification(lead)
            
          } catch (error) {
            console.log(error)
          }
          this.message = a.result.description
          this.paid = true
          this.loading = false
        } else {
          await store.collection('leads').doc(a.customer.merchantCustomerId).update({
            paid:false,
            payment_tried:true,
            payment_status:'fail',
            payment_api_response:true,
            payment_timestamp:new Date().getTime(),
            payment_failed_date:getCDate(),
            payment_failed:true,
            payment_result:a.result.description
          })
          this.message = a.result.description
          this.paid = false
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.paid = false
        this.loading = false
      }
      
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    eraseCookie(name) {   
      document.cookie = name+'=; Max-Age=-99999999;';  
    },
    trackSnap(){
      if (this.getCookie('ashsnapco') && this.getCookie('ashsnapco') != window.location.href) {
        snaptr('track', 'PURCHASE');
        this.setCookie('ashsnapco', window.location.href, 1);
      } else if (!getCookie('ashsnapco')) {
        snaptr('track', 'PURCHASE');
        this.setCookie('ashsnapco', window.location.href, 1);
      }
    }
  },
  async created(){
    let p = this.$route.query
    if(p && p.id) {
      this.loading = true
      this.cart_token = p.id
      console.log(this.cart_token)
      this.GetPaymentStatus(this.cart_token)
    } else {

    }
  }
}
</script>

<style>
.arFont { 
  font-family: 'Cairo', sans-serif !important;
  direction:rtl;
}
.arFontOnly { 
  font-family: 'Cairo', sans-serif !important;
}

.container {
  -webkit-box-align: center;
          align-items: center;
  background-color: #fff;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
          justify-content: center;
}

@-webkit-keyframes scaleAnimation {
  0% {
    opacity: 0;
    -webkit-transform: scale(1.5);
            transform: scale(1.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes scaleAnimation {
  0% {
    opacity: 0;
    -webkit-transform: scale(1.5);
            transform: scale(1.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@-webkit-keyframes drawCircle {
  0% {
    stroke-dashoffset: 300px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes drawCircle {
  0% {
    stroke-dashoffset: 300px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes drawCheck {
  0% {
    stroke-dashoffset: 35px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes drawCheck {
  0% {
    stroke-dashoffset: 35px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes drawLine {
  from {
    stroke-dashoffset: 100;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes drawLine {
  from {
    stroke-dashoffset: 100;
  }
  to {
    stroke-dashoffset: 0;
  }
}
#successAnimationCircle,
#failureAnimationCircle {
  stroke-dasharray: 300px 300px;
  stroke: #005596;
}

#successAnimationCheck,
#failureAnimationCheck {
  stroke-dasharray: 35px 35px;
  stroke: #005596;
}

#successAnimation.animated,
#failureAnimation.animated {
  -webkit-animation: 1s ease-out 0s 1 both scaleAnimation;
          animation: 1s ease-out 0s 1 both scaleAnimation;
}
#successAnimation.animated #successAnimationCircle,
#successAnimation.animated #failureAnimationCircle,
#failureAnimation.animated #successAnimationCircle,
#failureAnimation.animated #failureAnimationCircle {
  -webkit-animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle;
          animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle;
}
#successAnimation.animated #successAnimationCheck,
#failureAnimation.animated #successAnimationCheck {
  -webkit-animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck;
          animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck;
}
#successAnimation.animated .failureAnimationCheckLine,
#failureAnimation.animated .failureAnimationCheckLine {
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  -webkit-animation: drawLine 1s cubic-bezier(1, 0.2, 0.1, 1) forwards;
          animation: drawLine 1s cubic-bezier(1, 0.2, 0.1, 1) forwards;
}

#animate {
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  border: 0;
  border-radius: 3px;
  bottom: 100px;
  color: #005596;
  left: 50%;
  outline: 0;
  padding: 10px 30px;
  position: absolute;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}
#animate:active {
  background: rgba(255, 255, 255, 0.1);
}
</style>